export const getCookie = (name: string) => {
  const cookie = document.cookie.split('; ').find(row => row.startsWith(name));
  return cookie ? cookie.split('=')[1] : '';
};

export const setCookie = (name: string, value: string, exp: number) => {
  const d = new Date();
  d.setTime(d.getTime() + exp);
  const expires = 'expires=' + d.toUTCString();
  document.cookie = name + '=' + value + ';' + expires + ';path=/';
};

export const deleteCookie = (name: string) => {
  document.cookie = `${name}=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
};
